import { z } from 'zod';

export const LoginInputSchema = z.object({
    email: z.string().nonempty("E-mail nesmí být prázdný").email("Musíte zadat platný email"),
    password: z.string().nonempty("Heslo nesmí být prázdné"),
    confirm: z.boolean().optional(),
})
export type TLoginInput = z.infer<typeof LoginInputSchema>;
